import { EventEmitter } from '@angular/core';
import {
  BasketManagerTableComponent,
  Dictionary,
} from '@epicuro-next/platform/dynamic-components';
import {
  BasketManagerOrderByType,
  UserExtended,
} from 'graphql-api/baskets-api-interfaces';
import { Observable, Subject } from 'rxjs';

import { OrderTypeColumn } from './order-type-column.model';

export enum BasketManagerTableProps {
  BasketId = 'basketId',
  Brands = 'brands',
  OrderReferenceNumber = 'orderReferenceNumber',
  ClientReferenceNumber = 'clientReferenceNumber',
  LastUpdated = 'lastUpdated',
  CreatedBy = 'createdBy',
  Status = 'status',
  Accounts = 'accounts',
  Quantity = 'quantity',
  Value = 'value',
  Checkbox = 'checkbox',
  OrderType = 'orderType',
  SubmittedBy = 'submittedBy',
}

export interface BasketManagerLineCell {
  key: BasketManagerTableProps;
  // eslint-disable-next-line @typescript-eslint/ban-types
  value: string | number | object;
  gridClasses: string | number;
  title: string;
}

export interface BasketManagerLine {
  id: string;
  tableData: BasketManagerLineCell[];
}

export interface BasketManagerCellValue {
  [BasketManagerTableProps.BasketId]: string;
  [BasketManagerTableProps.Brands]: string[];
  [BasketManagerTableProps.OrderReferenceNumber]: string;
  [BasketManagerTableProps.ClientReferenceNumber]: string;
  [BasketManagerTableProps.LastUpdated]: string;
  [BasketManagerTableProps.CreatedBy]: UserExtended;
  [BasketManagerTableProps.Status]: string;
  [BasketManagerTableProps.Accounts]: string[];
  [BasketManagerTableProps.Quantity]: number;
  [BasketManagerTableProps.OrderType]: OrderTypeColumn;
  [BasketManagerTableProps.SubmittedBy]: UserExtended;
  [BasketManagerTableProps.Value]: {
    requested: ValueWithCurrency;
    confirmed?: ValueWithCurrency;
  };
}

export type ValueWithCurrency = { value: number; currency: string };

// sonar gives false positive error, const cast IS useful for SortableColumns type
/* tslint:disable:no-useless-cast */
export const SORTABLE_COLUMNS = [
  BasketManagerTableProps.LastUpdated,
  BasketManagerTableProps.Value,
] as const;
/* tslint:enable:no-useless-cast */

export type SortableColumns = typeof SORTABLE_COLUMNS[number];

export type ColKeysToSorting = {
  [key in SortableColumns]: BasketManagerOrderByType;
};

export const sortKeyMap: ColKeysToSorting = {
  [BasketManagerTableProps.LastUpdated]:
    BasketManagerOrderByType.LastUpdatedUtc,
  [BasketManagerTableProps.Value]: BasketManagerOrderByType.Value,
};

export interface SortParams {
  type?: BasketManagerOrderByType;
  ascending?: boolean;
}

export type IGenericComponentsData = {
  [key in BasketManagerTableProps]?: {
    contentTypeId: BasketManagerTableComponent;
    data: Dictionary<unknown>;
  };
};

export type IComponentsData = {
  [BasketManagerTableProps.Checkbox]?: {
    contentTypeId: BasketManagerTableComponent.Checkbox;
    data: {
      isSelected$: Observable<boolean>;
      selectableId: string;
      showCheckbox$: Observable<boolean>;
      selectionChange$$: Subject<void>;
    };
  };
  [BasketManagerTableProps.OrderReferenceNumber]?: {
    contentTypeId: BasketManagerTableComponent.Button;
    data: {
      onClick: EventEmitter<string>;
    };
  };
};
